import { S3_IMG_BUCKET } from 'src/consts/user-web.const';

export const FESTIVAL_NAME = '아델란테(Adelante) 축제';
export const STAMP_TITLE = '탄소 중립 스탬프 랠리';
export const STAMP_DOING = '랠리';
export const STAMP_USER_JOB = '참여자';

// 스탬프투어 관련 이미지들
export const STAMP_START_BACKGROUND = `${S3_IMG_BUCKET}StampStartBackground.webp`;
export const STAMP_BACKGROUND = `${S3_IMG_BUCKET}StampBackground.webp`;
export const STAMP_START_LOGO = `${S3_IMG_BUCKET}StampStartLogo.webp`;
export const STAMP_PRIZE_LOGO = `${S3_IMG_BUCKET}StampPrizeLogo.webp`;
export const STAMP_COMPLETE_THUMBNAIL = `${S3_IMG_BUCKET}StampCompleteThumbnail.webp`;
export const STAMP_GUIDE = `${S3_IMG_BUCKET}StampGuide.webp`;

export const STAMP_START_P =
  '축제장 곳곳에 있는 미션들을 수행하고\n특별한 경품을 획득하자!';

export const STAMP_FONT = 'TAEBAEKfont';

export const STAMP_COMPLETE_HEADER = '스탬프 랠리';
export const STAMP_COMPLETE_PLACE = `${STAMP_TITLE} 운영부스`;
export const STAMP_COMPLETE_POPUP_COMMENT =
  '경품 수령을 위해 지도 버튼을 클릭하여\n스탬프 부스를 방문해주세요.\n( 8개 완료 시 - 리사이클백 / 9개 완료 시 - 인형 키링 )';

export const STAMP_INFO_BOOTH_ID = 289;
export const STMAP_SIGNUP_CAUTION_FOOTER = [
  '개인정보 수집에 동의하지 않을 경우,\n이벤트에 참여하실 수 없습니다.',
  '상품은 스탬프 투어 완료 후, 선착순 지급됩니다.',
];

export const STAMP_SIGNUP_CAUTION_MODAL = `가. 수집 및 이용 목적
- 페스티맵에서 실시하는 “탄소중립 스탬프랠리"에 필요한 사항(참여자 중복 참여 방지, 참여 인원 확인 등)에 대하여 스탬프 투어 서비스 제공을 위하여 필요한 최소한의 범위 내에서 개인정보를 수집하고 있습니다.

나. 수집 및 이용 항목
1) 필수항목 : 성명, 전화번호

개인정보 수집 동의 항목 기입 시 페스티맵이 위와 같이 개인정보 필수항목을 수집ㆍ이용하는 것에 동의하는 것으로 간주합니다.

다. 개인정보의 보유 및 이용 기간
- 참여자의 개인정보 수집ㆍ이용에 관한 동의일로부터 2025제주들불축제 종료 시까지 위 이용목적을 위하여 보유 및 이용하게 됩니다. 단, 축제 종료 후에는 경품 증정, 민원처리, 분쟁해결 및 법령상 의무이행 등을 위하여 1년간 보유하게 됩니다.

라. 동의를 거부할 권리 및 동의를 거부할 경우의 불이익
- 위 개인정보 중 필수정보의 수집ㆍ이용에 관한 동의는 “탄소중립 스탬프랠리" 진행을 위해 필수적이므로, 위 사항에 동의하셔야만 프로그램 체험 및 상품 수령이 가능합니다.`;

export const STAMP_PRIZE_TEXT1 = `탄소 중립 스탬프 랠리 참여해\n환경을 지키며, 축제를 즐겨보세요.`;
export const STAMP_PRIZE_TEXT2 = `총 8개 이상 스탬프를\n모으면 자동으로 이벤트 참여 완료!`;

export const stampGuideList = [
  {
    thumbnail: '',
    title: '함덕 미션탐험 시작',
    content:
      '함덕 해수욕장 내\n6개 부스를 방문하고, 미션을 해결하여\n특별한 상품을 받아보세요.',
    ps: '',
  },
  {
    thumbnail: '',
    title: '탐험 미션 선택',
    content: '스탬프 판에 있는 6개의 미션 중\n하나를 선택하세요.',
    ps: '',
  },
  {
    thumbnail: '',
    title: '탐험 미션 수행',
    content: '미션장소와 미션내용을 확인하세요.',
    ps: 'TIP. 하단 지도버튼을 클릭하면, 상세 위치를\n확인할 수 있습니다.',
  },
  {
    thumbnail: '',
    title: '미션 완료 인증',
    content:
      '**미션 인증하기** 버튼을 클릭해 부스에 설치된\nQR 코드를 촬영해 완료 인증을 하세요.\n6개 미션을 완료하면, 상품 수령이 가능합니다.',
    ps: '',
  },
  {
    thumbnail: '',
    title: '탐험 미션 선택',
    content:
      '함덕미션탐험 부스에서 상품을 수령하세요.\n*지도를 통해 상품 수령 위치 확인',
    ps: '주의사항 : 상품이 소진 될 경우, 조기 마감될 수 있습니다.',
  },
];

export const stampPrizeList = [
  { id: 1, name: '획득 스탬프 8개', prize: '부리부리 리사이클백' },
  { id: 2, name: '획득 스탬프 9개', prize: '부리부리 인형 키링' },
];

export const stampPreClearList = [
  {
    id: 1,
    title: '지류 사용 줄이기',
    summary: `지류 안내책자 대신\n모바일 홈페이지를 이용해주셨군요!`,
  },
  {
    id: 2,
    title: '친환경 실천 목표세우기',
    summary: `입력해주신 친환경 목표를 꼭 지켜\n탄소 중립에 기여해주세요!`,
  },
];
